import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';

import FontAwesome from 'utils/FA';

import { feeRules } from '../../ducks';
import { duckify } from "utils/duckify";

import {SortableHandle}  from 'react-sortable-hoc';

import FeeGroupFeeModal from './FeeGroupFeeModal';
import FeeEntityDeletionModal from './FeeEntityDeletionModal';

const FeeGroupListItemTableRowSubsectionRow = ({ feeData, feeGroupId, feeRulesDelete }) => {

  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const deleteFee = () => {
    setShowDeleteModal(false);
    feeRulesDelete(feeData.id);
  };

  return (
    <React.Fragment>
        <td><DragHandle /></td>
        <td>{feeData.name}</td>
        <td>{feeData.description}</td>
        <td>{feeData.amount}</td>
        <td>{feeData.test}</td>
        <td>
          {feeData.active &&
            <FontAwesome icon={faCheck} />
          }
        </td>
        <td>
          <div className="fee-management-actions">
            <a className="fee-edit btn btn-primary btn-sm" onClick={() => setShowEditModal(true)}>
              <FontAwesome icon={faPencil} />
            </a>
            <a className="fee-delete btn btn-danger btn-sm" onClick={() => setShowDeleteModal(true)}>
              <FontAwesome icon={faTrash} />
            </a>
          </div>
        </td>

      {showEditModal &&
        <FeeGroupFeeModal closeModal={() => setShowEditModal(false)} feeGroupId={feeGroupId} editData={feeData} />
      }

      {
        showDeleteModal &&
        <FeeEntityDeletionModal
          closeModal={() => setShowDeleteModal(false)}
          submitTrigger={() => deleteFee()}
          deletionMsg='The fee will be deleted. This action cannot be reversed.'
        />
      }
    </React.Fragment>
  )
};

const mapDucksToProps = () => ({});
const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
  feeRulesDelete: (feeID) => {
    return dispatch(feeRules.actions.remove({ id: feeID })).then(() => dispatch(feeRules.actions.markDirty()))
  }
});

FeeGroupListItemTableRowSubsectionRow.propTypes = {
  feeGroupId: PropTypes.string,
  feeRuelsDelete: PropTypes.func,
  feeData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    amount: PropTypes.string,
    test: PropTypes.string,
    active: PropTypes.bool
  })
};

export default duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(FeeGroupListItemTableRowSubsectionRow);

const DragHandle = SortableHandle(() => (
  <span className='drag-handle'>
    <FontAwesome name={'reorder'} />
  </span>
));
